import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const OURO = { fontFamily: 'Outfit, sans-serif' };
function lerLocal(c) { try { return window.localStorage.getItem(c) || ''; } catch (e) { return ''; } }

export default function IndicarPage() {
  const [email, setEmail] = useState('');
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [copiado, setCopiado] = useState(false);

  async function buscar(e) {
    const alvo = (e || email).trim().toLowerCase();
    if (!alvo) return;
    setCarregando(true); setErro('');
    try {
      const r = await fetch('/api/curso/indicacao?email=' + encodeURIComponent(alvo));
      const d = await r.json().catch(function () { return {}; });
      if (r.ok) { setDados(d); } else { setErro(typeof d.detail === 'string' ? d.detail : 'Não encontramos esse e-mail.'); }
    } catch (x) { setErro('Sem conexão. Tente de novo.'); }
    setCarregando(false);
  }

  useEffect(function () {
    const salvo = lerLocal('giraia_gratis_email');
    if (salvo) { setEmail(salvo); buscar(salvo); }
    // eslint-disable-next-line
  }, []);

  const msg = dados ? 'Fiz a aula grátis de segurança para patinete, bike elétrica e scooter da Giraia Bike Shop e ganhei certificado! Faz também, é rapidinho: ' + dados.link : '';

  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA] px-4 py-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-giraia.jpg" alt="Giraia Bike Shop" className="w-12 h-12 rounded-full object-cover" />
            <span className="font-bold text-[#E2B84A]" style={OURO}>Giraia Bike Shop</span>
          </Link>
          <Link to="/curso/aluno" className="text-[#B8B3A8] underline">Voltar</Link>
        </div>
        <h1 className="text-4xl font-black text-[#E2B84A] mb-3" style={OURO}>Indique e ganhe</h1>
        <p className="text-xl text-[#B8B3A8] mb-8">Ajude seus amigos a andar com mais segurança e ganhe prêmios na Giraia.</p>
        <div className="bg-[#1E1A24] rounded-2xl p-6 mb-6">
          <h2 className="text-2xl font-black mb-4" style={OURO}>Como funciona</h2>
          <div className="space-y-4 text-lg">
            <p><b className="text-[#E2B84A]">1.</b> Faça a aula grátis e tire seu certificado. Você ganha um <b>link só seu</b>.</p>
            <p><b className="text-[#E2B84A]">2.</b> Mande o link para amigos, família e grupos de WhatsApp.</p>
            <p><b className="text-[#E2B84A]">3.</b> Cada amigo que fizer a aula pelo seu link e tirar o certificado vale <b>1 ponto</b>.</p>
          </div>
        </div>
        <div className="bg-[#1E1A24] rounded-2xl p-6 mb-6 border-2 border-[#E2B84A]">
          <h2 className="text-2xl font-black mb-4" style={OURO}>Prêmios</h2>
          <div className="space-y-3 text-lg">
            <div className="flex gap-4 items-start"><span className="shrink-0 w-24 text-center bg-[#E2B84A] text-[#141118] font-black rounded-full py-1">1 amigo</span><span>Brinde surpresa da loja</span></div>
            <div className="flex gap-4 items-start"><span className="shrink-0 w-24 text-center bg-[#E2B84A] text-[#141118] font-black rounded-full py-1">2 amigos</span><span>Busca e entrega grátis em Sorriso em um serviço da oficina</span></div>
            <div className="flex gap-4 items-start"><span className="shrink-0 w-24 text-center bg-[#E2B84A] text-[#141118] font-black rounded-full py-1">4 amigos</span><span>R$ 100 de desconto na mão de obra da revisão completa</span></div>
          </div>
        </div>
        <div className="bg-[#1E1A24] rounded-2xl p-6 mb-6">
          <h2 className="text-2xl font-black mb-4" style={OURO}>Meus pontos</h2>
          {dados ? (
            <div>
              <div className="bg-[#141118] rounded-xl p-4 mb-4 text-center">
                <p className="text-3xl font-black" style={OURO}>Você tem {dados.pontos} {dados.pontos === 1 ? 'ponto' : 'pontos'}</p>
                <p className="text-lg text-[#B8B3A8]">{dados.proximo ? 'Falta ' + dados.proximo.faltam + (dados.proximo.faltam === 1 ? ' amigo' : ' amigos') + ' para: ' + dados.proximo.premio : 'Você já ganhou todos os prêmios. Obrigada!'}</p>
              </div>
              <a href={'https://wa.me/?text=' + encodeURIComponent(msg)} target="_blank" rel="noopener noreferrer" className="block w-full text-center rounded-xl bg-[#25D366] text-white font-bold text-xl py-4 mb-3">Indicar pelo WhatsApp</a>
              <button onClick={function () { try { navigator.clipboard.writeText(dados.link); setCopiado(true); } catch (x) {} }} className="w-full rounded-xl border border-[#E2B84A] text-[#E2B84A] font-bold text-lg py-3">{copiado ? 'Link copiado!' : 'Copiar meu link'}</button>
            </div>
          ) : (
            <div>
              <p className="text-lg mb-3">Digite o e-mail que você usou na aula grátis:</p>
              <input type="email" value={email} onChange={function (e) { setEmail(e.target.value); }} placeholder="seu@email.com" className="w-full rounded-xl bg-[#141118] border border-[#3A3442] px-4 py-4 text-lg mb-3" />
              <button onClick={function () { buscar(); }} disabled={carregando} className="w-full rounded-xl bg-[#E2B84A] text-[#141118] font-bold text-xl py-4 mb-3 disabled:opacity-60">{carregando ? 'Buscando...' : 'Ver meus pontos'}</button>
              {erro && <p className="text-red-400 text-lg mb-3">{erro}</p>}
              <Link to="/curso/gratis" className="block text-center rounded-xl border border-[#E2B84A] text-[#E2B84A] font-bold text-lg py-3">Ainda não fiz: fazer a aula grátis</Link>
            </div>
          )}
        </div>
        <div className="text-[#9A948A] text-sm space-y-1 mb-10">
          <p>• Os pontos valem por 90 dias.</p>
          <p>• Um prêmio de cada nível por pessoa. Peças cobradas à parte.</p>
          <p>• Ao ganhar um prêmio, você recebe um e-mail. Retire na loja: Av. Ademar Raiter, 428, Centro Sul, Sorriso-MT.</p>
          <p>• Só conta o amigo que tirar o certificado da aula grátis pelo seu link.</p>
        </div>
      </div>
    </div>
  );
}
